<ng-container *ngIf="filterValue">
	<mat-form-field appearance="outline" subscriptSizing="dynamic" class="mat-form-field-custom-width copo-no-error-message">
		<input matInput [matAutocomplete]="auto" [formControl]="suggestiveCtrl"
				(keyup)="filterValue.code = undefined"
				[placeholder]="placeholder ? placeholder : ''" />
		<mat-autocomplete #auto="matAutocomplete">
			<mat-option disabled class="copo-mat-option-is-loading" *ngIf="isLoading">
				<copo-loading-spinner></copo-loading-spinner>
			</mat-option>
			<ng-container *ngIf="!isLoading">
				<mat-option *ngFor="let proposition of filteredItems"
							(onSelectionChange)="propositionChanged(proposition)">
							{{ proposition.translation }}
				</mat-option>
			</ng-container>
		</mat-autocomplete>
	</mat-form-field>
</ng-container>